import * as yup from 'yup';

export const createRoleDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  displayName: yup.string().required().label('Display Name'),
  description: yup.string().required().label('Description')
});

export const updateRoleDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  displayName: yup.string().required().label('Display Name'),
  description: yup.string().required().label('Description'),
  permissions: yup.array().of(yup.string().required()).required().label('Role Permissions')
});
